import styled, { css, keyframes } from 'styled-components';

const slideIn = keyframes`
    from {
        opacity: 0;
        transform: translateY(16px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
`;

export const ConsentCard = styled.aside`
    position: fixed;
    z-index: 1000;
    left: 24px;
    bottom: 24px;
    width: 380px;
    max-width: calc(100vw - 48px);
    padding: 24px;
    border: 1px solid ${({ theme }) => theme.colors.darkGrey};
    border-radius: 16px;
    background: rgba(2, 2, 2, 0.94);
    backdrop-filter: blur(16px);
    box-shadow: 0 16px 48px rgba(0, 0, 0, 0.6);
    animation: ${slideIn} 0.3s ease;

    @media (prefers-reduced-motion: reduce) {
        animation: none;
    }

    @media (max-width: ${({ theme }) => theme.breakpoints.sm}px) {
        left: 16px;
        right: 16px;
        bottom: 16px;
        width: auto;
        max-width: none;
        padding: 20px;
    }
`;

export const ConsentTitle = styled.h2`
    font-size: 20px;
    line-height: 24px;
    font-weight: 700;
    letter-spacing: -0.02em;
    margin: 0 0 12px;
`;

export const ConsentText = styled.p`
    font-size: 15px;
    line-height: 22px;
    color: ${({ theme }) => theme.colors.grey};
    margin: 0 0 20px;

    a {
        color: ${({ theme }) => theme.colors.white};
        text-decoration: underline;
    }
`;

export const ConsentActions = styled.div`
    display: flex;
    gap: 12px;
`;

/**
 * Both buttons share these dimensions deliberately. The GDPR requires refusing
 * consent to be as easy as granting it, so "Decline" must match "Accept" in
 * size and legibility rather than being demoted to a faint link.
 */
const consentButton = css`
    flex: 1;
    font-family: 'Syne', sans-serif;
    font-size: 16px;
    line-height: 20px;
    font-weight: 700;
    padding: 12px 16px;
    border-radius: 12px;
    text-align: center;
    white-space: nowrap;
    cursor: pointer;
    transition: all 0.2s ease;
`;

export const DeclineButton = styled.button`
    ${consentButton};
    color: ${({ theme }) => theme.colors.white};
    background: transparent;
    border: 1px solid rgba(255, 255, 255, 0.3);

    &:hover {
        border-color: ${({ theme }) => theme.colors.white};
    }
`;

export const AcceptButton = styled.button`
    ${consentButton};
    color: ${({ theme }) => theme.colors.white};
    background: ${({ theme }) => theme.colors.blue};
    border: 1px solid ${({ theme }) => theme.colors.blue};

    &:hover {
        opacity: 0.85;
    }
`;
